/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExportTaskListResponse } from '../models/export-task-list-response';
import { ExportTaskRequestBody } from '../models/export-task-request-body';
import { ExportTaskState } from '../models/export-task-state';

@Injectable({
  providedIn: 'root',
})
export class ExportJobApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getExportTasks
   */
  static readonly GetExportTasksPath = '/export/export-tasks';

  /**
   * Get list of export tasks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportTasks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportTasks$Response(params: {

    /**
     * The tenant id to be passed to the get export job api
     */
    'x-tenant-id': string;

    /**
     * The page no of the tasks requested
     */
    page: string;

    /**
     * The page size of the tasks requested
     */
    pageSize: string;

    /**
     * The status of the task
     */
    status: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExportTaskListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExportJobApiService.GetExportTasksPath, 'get');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.query('page', params.page, {});
      rb.query('pageSize', params.pageSize, {});
      rb.query('status', params.status, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportTaskListResponse>;
      })
    );
  }

  /**
   * Get list of export tasks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportTasks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportTasks(params: {

    /**
     * The tenant id to be passed to the get export job api
     */
    'x-tenant-id': string;

    /**
     * The page no of the tasks requested
     */
    page: string;

    /**
     * The page size of the tasks requested
     */
    pageSize: string;

    /**
     * The status of the task
     */
    status: string;
  },
  context?: HttpContext

): Observable<ExportTaskListResponse> {

    return this.getExportTasks$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExportTaskListResponse>) => r.body as ExportTaskListResponse)
    );
  }

  /**
   * Path part for operation postExportTasks
   */
  static readonly PostExportTasksPath = '/export/export-tasks';

  /**
   * Allow users to export task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postExportTasks()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  postExportTasks$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * Export task request
     */
    body: ExportTaskRequestBody
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExportTaskState>> {

    const rb = new RequestBuilder(this.rootUrl, ExportJobApiService.PostExportTasksPath, 'post');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportTaskState>;
      })
    );
  }

  /**
   * Allow users to export task.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postExportTasks$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  postExportTasks(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * Export task request
     */
    body: ExportTaskRequestBody
  },
  context?: HttpContext

): Observable<ExportTaskState> {

    return this.postExportTasks$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExportTaskState>) => r.body as ExportTaskState)
    );
  }

  /**
   * Path part for operation getFrequencyLimitationValidation
   */
  static readonly GetFrequencyLimitationValidationPath = '/validation/frequency-limitation';

  /**
   * Allow users to export task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFrequencyLimitationValidation()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  getFrequencyLimitationValidation$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * ExportAll task request
     */
    body: ExportTaskRequestBody
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExportTaskState>> {

    const rb = new RequestBuilder(this.rootUrl, ExportJobApiService.GetFrequencyLimitationValidationPath, 'post');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportTaskState>;
      })
    );
  }

  /**
   * Allow users to export task.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFrequencyLimitationValidation$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  getFrequencyLimitationValidation(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * ExportAll task request
     */
    body: ExportTaskRequestBody
  },
  context?: HttpContext

): Observable<ExportTaskState> {

    return this.getFrequencyLimitationValidation$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExportTaskState>) => r.body as ExportTaskState)
    );
  }

  /**
   * Path part for operation getExportTask
   */
  static readonly GetExportTaskPath = '/export/export-tasks/{taskId}';

  /**
   * Get export task by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportTask$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExportTaskState>> {

    const rb = new RequestBuilder(this.rootUrl, ExportJobApiService.GetExportTaskPath, 'get');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportTaskState>;
      })
    );
  }

  /**
   * Get export task by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportTask(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;
  },
  context?: HttpContext

): Observable<ExportTaskState> {

    return this.getExportTask$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExportTaskState>) => r.body as ExportTaskState)
    );
  }

}
